import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

import { drName } from "../redux/apiUrl";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    height: "100%",
    fontSize: 12,
    color: "#000",
    paddingBottom: 70,
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Roboto",
    color: "#000",
    marginBottom: 20,
  },
  textBold: {
    color: "#000",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 700,
    width: "48%",
  },

  textItalic: {

  },
  logo: {
    width: "100%",
    height: "15%",
  },
  headerright: {
    width: "auto",
    height: "40%",
  },

  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.3,
    zIndex: "-10",
  },
  gridContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
    fontSize: 12,
  },
  singleItem: {
    textAlign: "justify",
    width: "100%",
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    marginRight: 20,
    textAlign: "center",
    paddingTop: 80,
  },
  columDr: {
    flex: 1,
    textAlign: "center",
    marginLeft: 20,
  },
  firma: {
    width: 90,
    marginLeft: "35%",
    height: 80,
  },
});

const FilePdf = ({ data }) => {

  const { id,
    edad,
    contenido,
    tipoDocumento,
    doctor } = data;


  console.log(id)
  return (
    <Document>
      <Page style={styles.page}>
        <Image style={styles.logo} src="/images/headerright.png" fixed />
        <Image style={styles.watermark} src="/images/longLogo.png" fixed />

        {/* Edad */}
        <View style={styles.gridContainer} >
          <View style={styles.singleItem} >
            <Text style={styles.text}>
              {edad}
            </Text>
          </View>
        </View>

        {/* Title */}
        <View style={styles.gridContainer} >
          <View style={styles.singleItem} >
            <Text style={styles.title}>
              {tipoDocumento}
              {
                id == 5 && (
                  <Text style={styles.title}>: LO QUE LOS PADRES NECESITAN SABER</Text>
                )
              }
            </Text>
          </View>
        </View>

        {/* Company Information */}
        <View style={styles.gridContainer} >
          <View style={styles.singleItem} >
            {contenido.map((bloque, idx) => {
              if (bloque.type === "paragraph") {
                return (
                  <Text key={idx} style={styles.text}>
                    {bloque.content.map((part, i) => (
                      <Text
                        key={i}
                        style={[
                          part.bold && part.italic
                            ? { ...styles.textBold, ...styles.textItalic }
                            : part.bold
                              ? styles.textBold
                              : part.italic
                                ? styles.textItalic
                                : null,
                        ]}
                      >
                        {part.text}
                      </Text>
                    ))}
                  </Text>
                );
              }
              if (bloque.type === "list") {
                return (
                  <View key={idx} style={{ marginBottom: 5 }}>
                    {bloque.content.map((item, i) => (
                      <Text key={i} style={styles.text}>{item.text}</Text>
                    ))}
                  </View>
                );
              }
              return null;
            })}

          </View>
        </View>

        {/* Firmas */}
        <View style={styles.firmas}>
          <View style={styles.columDr}>
            <Image style={styles.firma} src="/images/firma.png" />
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>{data?.doctor?.printer_name}</Text>
            <Text style={styles.text}>{data?.doctor?.specialty}</Text>
          </View>
          {id == 1 && (
            <View style={styles.colum}>
              <Text style={styles.text}>______________________</Text>
              <Text style={styles.text}>Entregue Conforme</Text>
            </View>
          )}
        </View>

        {/* Footer */}
        {/* <Image style={styles.footerImage} src="/images/footerImage.png" /> */}
      </Page>
    </Document>
  )
}

export default FilePdf;